import { hotjar } from 'react-hotjar';

const Hotjar = (() => {
  const initialize = () => hotjar.initialize('2287241', '6');
  return {
    initialize,
  };
})();

export default Hotjar;
